module.exports = __webpack_public_path__ + "static/scale-model-of-kiefer-sutherland's-star-in-glendale-california-7395cab6c656e57f1103ad79f0c203e3.png";